export default (animationsLoaders) => (id) => ({
  init() {
    this.loadAnimationById(id)
  },
  
  loadAnimationById(id) {
    const animationLoader = animationsLoaders[id]
    if (!animationLoader) {
      console.error(`Animation loader "${id}" not found`)
      return
    }

    // Element ID is passed to not hardcode it within loaders
    animationLoader(id)
  },
})
